import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { Loading, Header, Nav, H1, Error, modalStyles } from './../../common';
import { Edit, Delete, Text } from './../../buttons';
import FileUploader from 'react-firebase-file-uploader';
import { firebaseStorage } from '../../../config/Fire';
import {
	playerFetch,
	toggleEdit,
	playerUpdate,
	onAvatarTextChange,
	onFnameTextChange,
	onSurnameTextChange,
	onInitialTextChange,
	onSquadNumTextChange,
	onPositionChange,
	playerNew,
	playerDelete,
} from './../../../actions/PlayerActions';
import { TextInput, Select } from '../../inputs';
import './Player.css';

class Player extends Component {
	constructor(props) {
		super(props);
		this.state = {
			playerAvatar: '',
			uploadLoading: false,
			uploadProgress: null,
			uploadSuccess: false,
			firstName: '',
			surname: '',
			initial: '',
			position: '',
			squadNumber: '',
			modal: false,
			toDelete: {},
			players: {},
			type: {
				0: 'Manager',
				1: 'Player',
			},
			playerPositions: {
				0: { name: 'Set position', id: 0 },
				1: { name: 'Goalkeeper', id: 1 },
				2: { name: 'Defender', id: 2 },
				3: { name: 'Midfielder', id: 3 },
				4: { name: 'Forward', id: 4 },
			},
			playerPositionsById: [0, 1, 2, 3, 4],
		};
		this.handleAvatarChange = this.handleAvatarChange.bind(this);
		this.handleFnameChange = this.handleFnameChange.bind(this);
		this.handleSurnameChange = this.handleSurnameChange.bind(this);
		this.handleInitalChange = this.handleInitalChange.bind(this);
		this.handlePositionChange = this.handlePositionChange.bind(this);
		this.handleSquadnumChange = this.handleSquadnumChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onAvatarTextChange = this.props._onAvatarTextChange.bind(this);
		this.onFnameTextChange = this.props._onFnameTextChange.bind(this);
		this.onSurnameTextChange = this.props._onSurnameTextChange.bind(this);
		this.onInitialTextChange = this.props._onInitialTextChange.bind(this);
		this.onSquadNumTextChange = this.props._onSquadNumTextChange.bind(this);
		this.toggleEdit = this.props._toggleEdit.bind(this);
		this.playerUpdate = this.props._playerUpdate.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleModalClose = this.handleModalClose.bind(this);
	}
	componentDidMount() {
		this.props._playerFetch();
	}

	componentWillUnmount() {}

	handleAvatarChange(v) {
		this.setState({ playerAvatar: v });
	}

	handleFnameChange(v) {
		this.setState({ firstName: v });
	}

	handleSurnameChange(v) {
		this.setState({ surname: v });
	}

	handleInitalChange(v) {
		this.setState({ initial: v });
	}

	handlePositionChange = (v, e) => {
		console.log('r', e);
		console.log('v', v);
		console.log(this.state.playerPositions[e].name, this.state.playerPositions[e].id);
		this.props.list[v].positionIndex
		this.props._onPositionChange(parseInt(v, 10), {
			position: this.state.playerPositions[e].name,
			positionIndex: this.state.playerPositions[e].id,
		});
	};

	handleSquadnumChange(v) {
		this.setState({ squadNumber: v });
	}

	handleDelete() {
		this.props._playerDelete(this.state.toDelete);
		this.setState({ modal: false, toDelete: {} });
	}

	handleModalClose() {
		this.setState({ modal: false });
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.state.firstName === '') {
			return null;
		}
		if (this.state.initial === '') {
			return null;
		}
		if (this.state.squadNumber === '') {
			return null;
		}
		this.props._playerNew({
			playerAvatar: this.state.playerAvatar,
			firstName: this.state.firstName,
			surname: this.state.surname,
			initial: this.state.initial,
			squadNumber: this.state.squadNumber,
		});
		this.setState({
			playerAvatar: '',
			firstName: '',
			surname: '',
			initial: '',
			squadNumber: '',
			uploadLoading: false,
			uploadProgress: null,
			uploadSuccess: false,
		});
	}

	_loading() {
		if (this.props.loading) return <Loading />;
		return null;
	}

	_renderList() {
		const title = (
			<li className="flexContainerRow">
				<div className="item small">
					<div className="listTitle">Image</div>
				</div>
				<div className="item small">
					<div className="listTitle">First name</div>
				</div>
				<div className="item small">
					<div className="listTitle">Surname</div>
				</div>
				<div className="item small">
					<div className="listTitle">Initial</div>
				</div>
				<div className="item small">
					<div className="listTitle">Position</div>
				</div>
				<div className="item small">
					<div className="listTitle">Squad num</div>
				</div>
				<div className="item small" />
			</li>
		);
		const items = this.props.listByID.map(v => (
			<li key={v} className="flexContainerRow">
				<div className="item small">
					{this.props.list[v].readOnly ? (
						<img src={this.props.list[v].playerAvatar} />
					) : this.props.list[v].onChange.uploaded ? (
						<img src={this.props.list[v].onChange.playerAvatar} />
					) : (
						<label
							style={{
								backgroundColor: 'grey',
								color: 'white',
								marginTop: 4,
								float: 'left',
								padding: 10,
								borderRadius: 2,
								pointer: 'cursor',
							}}>
							{this.state[this.props.list[v].surname.replace(/\s+/g, '').toLowerCase()]
								? this.state[this.props.list[v].surname.replace(/\s+/g, '').toLowerCase()].progress
								: 'Upload'}
							<FileUploader
								hidden
								accept="image/*"
								name="player_avatar"
								filename={file =>
									this.props.list[v].surname.replace(/\s+/g, '').toLowerCase() +
									new Date().getTime() +
									file.name.split('.')[1]
								}
								storageRef={firebaseStorage.ref('player-images')}
								onUploadStart={() => {
									this.setState({
										[this.props.list[v].surname.replace(/\s+/g, '').toLowerCase()]: { progress: 0 },
									});
								}}
								onUploadError={err =>
									this.setState({
										[this.props.list[v].surname.replace(/\s+/g, '').toLowerCase()]: {
											progress: 'Error',
										},
									})
								}
								onUploadSuccess={filename => {
									firebaseStorage
										.ref('player-images')
										.child(filename)
										.getDownloadURL()
										.then(url => {
											this.onAvatarTextChange(v, url);
											this.setState({
												[this.props.list[v].surname.replace(/\s+/g, '').toLowerCase()]: null,
											});
										});
								}}
								onProgress={progress =>
									this.setState({
										[this.props.list[v].surname.replace(/\s+/g, '').toLowerCase()]: {
											progress: progress,
										},
									})
								}
							/>
						</label>
					)}
				</div>
				<div className="item small">
					<TextInput
						inputId={'fname' + this.props.list[v].id}
						placeholder={this.props.list[v].name}
						label={null}
						value={
							this.props.list[v].readOnly
								? this.props.list[v].firstName
								: this.props.list[v].onChange.firstName
						}
						onTextChange={val => this.onFnameTextChange(v, val)}
						readonly={this.props.list[v].readOnly}
					/>
				</div>
				<div className="item small">
					<TextInput
						inputId={'surname' + this.props.list[v].id}
						placeholder={this.props.list[v].surname}
						label={null}
						value={
							this.props.list[v].readOnly
								? this.props.list[v].surname
								: this.props.list[v].onChange.surname
						}
						onTextChange={val => this.onSurnameTextChange(v, val)}
						readonly={this.props.list[v].readOnly}
					/>
				</div>
				<div className="item small">
					<TextInput
						inputId={'initial' + this.props.list[v].id}
						placeholder={this.props.list[v].initial}
						label={null}
						value={
							this.props.list[v].readOnly
								? this.props.list[v].initial
								: this.props.list[v].onChange.initial
						}
						onTextChange={val => this.onInitialTextChange(v, val)}
						readonly={this.props.list[v].readOnly}
					/>
				</div>
				<div className="item small">
					{this.props.list[v].readOnly ? (
						<TextInput
							inputId={'position' + this.props.list[v].id}
							placeholder={this.props.list[v].position}
							label={null}
							value={this.props.list[v].position}
							readonly={this.props.list[v].readOnly}
						/>
					) : (
						<Select
							currentVal={this.props.list[v].onChange.positionIndex}
							options={this.state.playerPositions}
							optionsById={this.state.playerPositionsById}
							onChange={e => this.handlePositionChange(v, e)}
						/>
					)}
				</div>
				<div className="item small">
					<TextInput
						inputId={'squadnum' + this.props.list[v].id}
						placeholder={this.props.list[v].squadNumber}
						label={null}
						value={
							this.props.list[v].readOnly
								? this.props.list[v].squadNumber
								: this.props.list[v].onChange.squadNumber
						}
						onTextChange={val => this.onSquadNumTextChange(v, val)}
						readonly={this.props.list[v].readOnly}
					/>
				</div>
				<div className="item small">
					<div className="flexContainerRow">
						{this.props.list[v].readOnly ? (
							<div>
								<Edit action={() => this.toggleEdit(v)} />
							</div>
						) : (
							<div className="buttonText">
								<Text text="Save" action={val => this.playerUpdate(this.props.list[v].onChange)} />
							</div>
						)}
						{this.props.list[v].readOnly ? (
							<div>
								<Delete
									action={() =>
										this.setState({
											modal: true,
											toDelete: this.props.list[v],
										})
									}
								/>
							</div>
						) : (
							<div className="buttonText">
								<Text text="Cancel" action={() => this.toggleEdit(v)} />
							</div>
						)}
						{this.props.list[v].error ? <Error text={this.props.list[v].errorText} /> : null}
					</div>
				</div>
			</li>
		));
		return (
			<ul>
				{title}
				{items}
			</ul>
		);
	}

	render() {
		return (
			<div>
				<Header />
				<div className="container">
					<Nav />
					<div className="player">
						<H1 text={'Players'} />
						<p>Create an Arsenal player. Match day squads are populated from this list</p>
						<div className="section">
							<form className="flexContainerRow">
								<div className="item small">
									{this.state.uploadSuccess ? (
										<img src={this.state.playerAvatar} />
									) : (
										<label
											style={{
												backgroundColor: 'grey',
												color: 'white',
												marginTop: 4,
												float: 'left',
												padding: 10,
												borderRadius: 2,
												pointer: 'cursor',
											}}>
											{this.state.uploadLoading ? this.state.uploadProgress : 'Upload'}
											<FileUploader
												hidden
												accept="image/*"
												name="player_avatar"
												filename={file =>
													file.name
														.split('.')[0]
														.replace(/\s+/g, '')
														.toLowerCase() +
													new Date().getTime() +
													file.name.split('.')[1]
												}
												storageRef={firebaseStorage.ref('player-images')}
												onUploadStart={() => {
													this.setState({
														uploadLoading: true,
														uploadProgress: 0,
													});
												}}
												onUploadError={err =>
													this.setState({
														uploadProgress: 'Error',
													})
												}
												onUploadSuccess={filename => {
													firebaseStorage
														.ref('player-images')
														.child(filename)
														.getDownloadURL()
														.then(url => {
															this.setState({
																playerAvatar: url,
																uploadLoading: false,
																uploadProgress: null,
																uploadSuccess: true,
															});
														});
												}}
												onProgress={progress =>
													this.setState({
														uploadProgress: progress,
													})
												}
											/>
										</label>
									)}
								</div>
								<div className="item small">
									<TextInput
										inputId={'fnam'}
										placeholder="First name"
										label={null}
										value={this.state.firstName}
										onTextChange={this.handleFnameChange}
									/>
								</div>
								<div className="item small">
									<TextInput
										inputId={'surname'}
										placeholder="Surname"
										label={null}
										value={this.state.surname}
										onTextChange={this.handleSurnameChange}
									/>
								</div>
								<div className="item small">
									<TextInput
										inputId={'initial'}
										placeholder="Initials"
										label={null}
										value={this.state.initial}
										onTextChange={this.handleInitalChange}
									/>
								</div>
								<div className="item small">
									<TextInput
										inputId={'squadnum'}
										placeholder="Squad num"
										label={null}
										value={this.state.squadNumber}
										onTextChange={this.handleSquadnumChange}
									/>
								</div>
								<div className="item small">
									<div className="buttonText">
										<Text text="Create" action={this.handleSubmit} />
									</div>
								</div>
							</form>
						</div>
						<p>Edit existing Arsenal player.</p>
						{this._renderList()}
					</div>
				</div>
				{this._loading()}
				<ReactModal
					isOpen={this.state.modal}
					onRequestClose={this.handleModalClose}
					style={modalStyles}
					ariaHideApp={false}
					contentLabel="Confirm">
					<h2 style={{ textAlign: 'center' }}>
						Delete player: {this.state.toDelete.firstName + ' ' + this.state.toDelete.surname}
					</h2>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div style={{ flex: 1 }}>
							<Text text="Delete" action={this.handleDelete} />
						</div>
						<div style={{ flex: 1 }}>
							<Text text="Cancel" action={this.handleModalClose} />
						</div>
					</div>
				</ReactModal>
			</div>
		);
	}
}

const mapStateToProps = ({ player }) => {
	const { loading, errorText, list, listByID } = player;

	return {
		loading,
		errorText,
		list,
		listByID,
	};
};

const mapDispatchToProps = dispatch => ({
	_playerFetch: () => dispatch(playerFetch()),
	_toggleEdit: id => dispatch(toggleEdit(id)),
	_playerUpdate: obj => dispatch(playerUpdate(obj)),
	_onAvatarTextChange: (id, text) => dispatch(onAvatarTextChange(id, text)),
	_onFnameTextChange: (id, text) => dispatch(onFnameTextChange(id, text)),
	_onSurnameTextChange: (id, text) => dispatch(onSurnameTextChange(id, text)),
	_onInitialTextChange: (id, text) => dispatch(onInitialTextChange(id, text)),
	_onPositionChange: (id, text) => dispatch(onPositionChange(id, text)),
	_onSquadNumTextChange: (id, text) => dispatch(onSquadNumTextChange(id, text)),
	_playerNew: obj => dispatch(playerNew(obj)),
	_playerDelete: obj => dispatch(playerDelete(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Player);



// WEBPACK FOOTER //
// ./src/components/screens/player/Player.js